import React, { useRef } from 'react';
var VeltNotificationsPanelReadAllButton = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-read-all-button", { ref: ref }, children));
};
export default VeltNotificationsPanelReadAllButton;
